import React, { useState } from 'react';
import styled from 'styled-components';
import { AnimatePresence, motion } from 'framer-motion';

const DesignSlider = ({
  handleClick,
  sport,
  jerseyType,
  design,
  isMobile,
  disabled,
}) => {
  const images = [
    `https://res.cloudinary.com/team-triton/image/upload/f_auto,q_auto,w_260/${sport}/${
      sport === 'greek' ? jerseyType.split('-').join('/') : jerseyType
    }/${design.number}`,
  ];

  if (design.hasModel) {
    images.push(
      `https://res.cloudinary.com/team-triton/image/upload/f_auto,q_auto,w_260/${sport}/${
        sport === 'greek' ? jerseyType.split('-').join('/') : jerseyType
      }/${design.number}_model`
    );
  }

  const click = e => {
    if (disabled) return;
    handleClick(e);
  };

  const [currentImgIndex, setCurrentImgIndex] = useState(0);

  const handleHover = () => {
    setCurrentImgIndex(
      currentImgIndex === images.length - 1 ? 0 : currentImgIndex + 1
    );
  };

  if (isMobile)
    return (
      <SliderContainer
        onClick={handleHover}
        disabled={disabled}
        isApparel={sport === 'apparel'}
      >
        <AnimatePresence initial={false}>
          <motion.img
            key={images[currentImgIndex]}
            src={images[currentImgIndex]}
            initial={{ opacity: 1, x: -224 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 1, x: 224 }}
          />
        </AnimatePresence>
        {images.length > 1 && (
          <div className="see-more">
            <h4>Press to see example(s)</h4>
          </div>
        )}
      </SliderContainer>
    );

  return (
    <SliderContainer
      onMouseEnter={handleHover}
      onMouseLeave={handleHover}
      onClick={click}
      disabled={disabled}
      isApparel={sport === 'apparel'}
    >
      {images.map(img => (
        <motion.img
          key={img}
          src={img}
          alt="design"
          animate={{ opacity: img === images[currentImgIndex] ? 1 : 0 }}
        />
      ))}
    </SliderContainer>
  );
};

const SliderContainer = styled.div`
  overflow: hidden;
  width: ${props => (props.isApparel ? '320px' : '259px')};
  height: 200px;
  border: ${props => (props.isFocused ? '1px solid #000' : 'none')};
  position: relative;
  opacity: ${props => (props.disabled ? 0.5 : 1)};
  transition: opacity 0.25s;

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .see-more {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 2;
    background-color: rgba(0, 0, 0, 0.5);
    color: #fff;
    text-align: center;
    padding: 1rem 0;
    pointer-events: none;

    h4 {
      margin: 0;
    }
  }
`;

export default DesignSlider;
